import MarinSSO from 'marin-sso';
import getQueryValue from 'helpers/get-query-value';

(() => {
  // Find script that loaded marinSSO.js and parse configuration from script body.
  const scripts = document.querySelectorAll('script');
  let script: HTMLScriptElement | undefined = undefined;
  let foundScript = false;
  for (let i = 0; i < scripts.length; i++) {
    script = scripts.item(i);
    if (script.src && script.src.indexOf('js/marinSSO.js') !== -1) {
      foundScript = true;
      break;
    }
  }

  let siteID: string | undefined;
  try {
    createCaptcha();
    if (!foundScript || !script) {
      throw new Error('Cannot find marinSSO.js script tag. Do not bundle with other scripts - must be loaded by itself.');
    }
    siteID = getQueryValue('siteID', script.src.substr(script.src.indexOf('?') + 1));
    if (!siteID) {
      throw new Error('Site ID must be passed to marinSSO.js script tag via query string. For example: marinSSO.js?siteID=<SITE ID HERE>');
    }
  } catch (e) {
    if (typeof console === 'object' && console?.error) {
      console.error('Error initializing Marin SSO: ' + e.message);
    }
    return;
  }

  // The API is hosted on the same host that the script is loaded from.
  const src = script.getAttribute('src') as string;
  const endpoint = src.substr(0, src.indexOf('js/marinSSO.js'));
  window.marinSSO = new MarinSSO(endpoint, siteID);
})();

/**
 * Add recaptcha plugin in script tag
 */
function createCaptcha() {
  const captcha = document.createElement('script');
  captcha.type = 'text/javascript';
  captcha.async = true;
  captcha.src = 'https://www.google.com/recaptcha/api.js';
  const s: any = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(captcha, s);
}
